<div class="customer-result-item" *ngIf="customer" routerLink="/customer/{{customer.guid}}">
    <div class="col icon"><mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="person"></mat-icon></div>
    <div class="col identifier-name">
    <div class="item">Name:</div>
    <div class="item">Country:</div>
    </div>
    <div class="col identifier-content">
        <div class="item">{{ customer.legalName }}</div>
        <div class="item">{{ customer.address.length > 0 ? customer.address[0].country : "Unknown" }}</div>
        </div>    
    <div class="col additional-name">
        <div class="item">ID:</div>
        <div class="item"></div>
    </div>
    <div class="col additional-content">
        <div class="item">{{ customer.guid }}&nbsp;</div>
        <div class="item">&nbsp;</div>
    </div>    
</div>

<div class="asset-result-item" *ngIf="!customer">
    Error loading customer details.
</div>